import "./style.css";

export default class Hero {
  static selector = ".s-profile";

  constructor(block) {
    this.block = block;
    this.$sections = block.querySelectorAll(".s-profile__section");
    this.open = false;
    this.addListeners();
  }

  onSectionClick($section) {
    const isOpen = $section.getAttribute("data-open");
    $section.setAttribute("data-open", isOpen === "true" ? "false" : "true");
  }

  addListeners() {
    this.$sections.forEach(($section) => {
      const $cta = $section.querySelector(".s-profile__section-menu");
      $cta.addEventListener("click", () => {
        this.onSectionClick($section);
      });
    });
  }

  onReady() {}
}
